/**
 * AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
 * Generated by: scripts/generate-template-loaders.js
 * Source files:
 *   - payroll-payslip.njk
 *   - payroll-payslip.css
 */

export const PAYROLL_PAYSLIP_TEMPLATE = `<div class="a4-container">
  <!-- Header Row (50/50 Split) -->
  <div class="a4-hdr-row">
    <div class="a4-hdr-left">
      {% if logoUrl %}
        <img class="a4-hdr-logo-img" src="{{ logoUrl }}" alt="{{ companyName }}"/>
      {% endif %}
    </div>
    <div class="a4-hdr-right-store">
      <div class="store-title">{{ companyName }}</div>
      {% if companyAddress %}
        <p>{{ companyAddress | replace('\\n', ', ') }}</p>
      {% endif %}
      {% if companyPhone %}
        <p>Tel: {{ companyPhone }}</p>
      {% endif %}
    </div>
  </div>

  <!-- Horizontal Metadata Row -->
  <div class="a4-meta-row">
    <div class="a4-meta-col">
      <span class="a4-meta-lbl">VOUCHER TYPE</span>
      <strong class="a4-meta-val">SALARY PAYSLIP</strong>
    </div>
    <div class="a4-meta-col">
      <span class="a4-meta-lbl">PAYROLL MONTH</span>
      <strong class="a4-meta-val">{{ payrollMonth }}</strong>
    </div>
    <div class="a4-meta-col">
      <span class="a4-meta-lbl">DATE / TIME</span>
      <strong class="a4-meta-val">{{ generatedAt }}</strong>
    </div>
    <div class="a4-meta-col text-right">
      <span class="a4-meta-lbl">STATUS</span>
      <span class="status-badge-a4 {{ status | lower }}">{{ status or "N/A" }}</span>
    </div>
  </div>

  <!-- Employee Info Cards (Card Grid like Classic Invoice) -->
  <div class="a4-cust-card">
    <div class="a4-cust-grid">
      <span class="a4-cust-lbl">Employee Name:</span>
      <span class="a4-cust-val">{{ employeeName }}</span>

      <span class="a4-cust-lbl">Designation:</span>
      <span class="a4-cust-val">{{ designation }}</span>

      <span class="a4-cust-lbl">NIC No:</span>
      <span class="a4-cust-val">{{ nic }}</span>

      <span class="a4-cust-lbl">EPF / ETF Reg No:</span>
      <span class="a4-cust-val">{{ epfEtfNo }}</span>

      <span class="a4-cust-lbl">Structure Type:</span>
      <span class="a4-cust-val">{{ salaryType }}</span>

      <span class="a4-cust-lbl">Attendance:</span>
      <span class="a4-cust-val">Present: {{ presentDays }} | Absent: {{ absentDays }}</span>

      <span class="a4-cust-lbl">Payment Method:</span>
      <span class="a4-cust-val">{{ paymentMethod }} {% if paidAt %}({{ paidAt }}){% endif %}</span>
    </div>
  </div>

  <!-- Items Table (Classic a4-items-table styling) -->
  <table class="a4-items-table">
    <thead>
      <tr>
        <th class="a4-col-no">NO</th>
        <th class="a4-col-desc">SALARY COMPONENT DESCRIPTION</th>
        <th class="a4-col-earnings">EARNINGS (LKR)</th>
        <th class="a4-col-deductions">DEDUCTIONS (LKR)</th>
      </tr>
    </thead>
    <tbody>
      {% set itemIndex = 1 %}
      <!-- Basic Salary -->
      <tr class="a4-item-row">
        <td class="a4-col-no">{{ itemIndex }}</td>
        <td class="a4-desc-cell"><strong>Basic Salary</strong></td>
        <td class="a4-amount-cell"><strong>{{ basicSalary }}</strong></td>
        <td class="a4-amount-cell">—</td>
      </tr>
      {% set itemIndex = itemIndex + 1 %}

      {% if attendanceAllowancePaid != '0.00' %}
      <tr class="a4-item-row">
        <td class="a4-col-no">{{ itemIndex }}</td>
        <td class="a4-desc-cell">Attendance Allowance Paid <small style="color:#555;">(Allocated: {{ allocatedAttendanceAllowance }})</small></td>
        <td class="a4-amount-cell">{{ attendanceAllowancePaid }}</td>
        <td class="a4-amount-cell">—</td>
      </tr>
      {% set itemIndex = itemIndex + 1 %}
      {% endif %}

      {% if fuelTransport != '0.00' %}
      <tr class="a4-item-row">
        <td class="a4-col-no">{{ itemIndex }}</td>
        <td class="a4-desc-cell">Fuel / Transport Allowance</td>
        <td class="a4-amount-cell">{{ fuelTransport }}</td>
        <td class="a4-amount-cell">—</td>
      </tr>
      {% set itemIndex = itemIndex + 1 %}
      {% endif %}

      {% if productionIncentive != '0.00' %}
      <tr class="a4-item-row">
        <td class="a4-col-no">{{ itemIndex }}</td>
        <td class="a4-desc-cell">Production Incentive</td>
        <td class="a4-amount-cell">{{ productionIncentive }}</td>
        <td class="a4-amount-cell">—</td>
      </tr>
      {% set itemIndex = itemIndex + 1 %}
      {% endif %}

      {% if otAmount != '0.00' %}
      <tr class="a4-item-row">
        <td class="a4-col-no">{{ itemIndex }}</td>
        <td class="a4-desc-cell">Overtime (OT) Earnings <small style="color:#555;">({{ otHours }} hrs @ LKR {{ otRateHour }}/hr)</small></td>
        <td class="a4-amount-cell">{{ otAmount }}</td>
        <td class="a4-amount-cell">—</td>
      </tr>
      {% set itemIndex = itemIndex + 1 %}
      {% endif %}

      {% if otherAllowances != '0.00' %}
      <tr class="a4-item-row">
        <td class="a4-col-no">{{ itemIndex }}</td>
        <td class="a4-desc-cell">Other Fixed Allowances</td>
        <td class="a4-amount-cell">{{ otherAllowances }}</td>
        <td class="a4-amount-cell">—</td>
      </tr>
      {% set itemIndex = itemIndex + 1 %}
      {% endif %}

      {% if nopayDeduction != '0.00' %}
      <tr class="a4-item-row">
        <td class="a4-col-no">{{ itemIndex }}</td>
        <td class="a4-desc-cell">No-Pay Leave Deduction <small style="color:#555;">({{ nopayDays }} days)</small></td>
        <td class="a4-amount-cell">—</td>
        <td class="a4-amount-cell">{{ nopayDeduction }}</td>
      </tr>
      {% set itemIndex = itemIndex + 1 %}
      {% endif %}

      {% if employeeEpf != '0.00' %}
      <tr class="a4-item-row">
        <td class="a4-col-no">{{ itemIndex }}</td>
        <td class="a4-desc-cell">EPF Employee (8% Statutory Contribution)</td>
        <td class="a4-amount-cell">—</td>
        <td class="a4-amount-cell">{{ employeeEpf }}</td>
      </tr>
      {% set itemIndex = itemIndex + 1 %}
      {% endif %}

      {% if salaryAdvance != '0.00' %}
      <tr class="a4-item-row">
        <td class="a4-col-no">{{ itemIndex }}</td>
        <td class="a4-desc-cell">Salary Advance Deduction</td>
        <td class="a4-amount-cell">—</td>
        <td class="a4-amount-cell">{{ salaryAdvance }}</td>
      </tr>
      {% set itemIndex = itemIndex + 1 %}
      {% endif %}

      {% if otherDeductions != '0.00' %}
      <tr class="a4-item-row">
        <td class="a4-col-no">{{ itemIndex }}</td>
        <td class="a4-desc-cell">Other Fixed Deductions</td>
        <td class="a4-amount-cell">—</td>
        <td class="a4-amount-cell">{{ otherDeductions }}</td>
      </tr>
      {% set itemIndex = itemIndex + 1 %}
      {% endif %}
    </tbody>
  </table>

  <!-- Modern Summary Section -->
  <div class="a4-summary-container">
    <div class="a4-summary-left-card">
      <div class="a4-info-row">
        <span class="a4-info-label">Net Basic (Basic - No-Pay)</span>
        <span class="a4-info-value">LKR {{ netBasic }}</span>
      </div>
      <div class="a4-info-row">
        <span class="a4-info-label">Net Allowances (Allowances - Advance)</span>
        <span class="a4-info-value">LKR {{ netAllowances }}</span>
      </div>
      <div class="a4-info-row">
        <span class="a4-info-label">Net Payable Basic (excl. EPF 8%)</span>
        <span class="a4-info-value">LKR {{ netPayableBasic }}</span>
      </div>
      <div class="a4-info-row">
        <span class="a4-info-label">Net Payable Allowances</span>
        <span class="a4-info-value">LKR {{ netPayableAllowances }}</span>
      </div>
    </div>
    <div class="a4-summary-right-totals">
      <div class="a4-total-row">
        <span class="a4-total-lbl">Gross Basic & Allowances</span>
        <span class="a4-total-val">LKR {{ grossEarnings }}</span>
      </div>
      <div class="a4-total-row">
        <span class="a4-total-lbl">Total Deductions</span>
        <span class="a4-total-val">- LKR {{ totalDeductions }}</span>
      </div>
      <div class="a4-grand-total-row">
        <span class="a4-grand-lbl">NET SALARY PAYABLE</span>
        <span class="a4-grand-val">LKR {{ netSalary }}</span>
      </div>
      <div style="border-top: 1px dashed #dee2e6; margin-top: 5px; padding-top: 5px;"></div>
      <div class="a4-total-row" style="font-weight: 600;">
        <span class="a4-total-lbl">Payment Status</span>
        <span class="a4-total-val">{{ status }}</span>
      </div>
    </div>
  </div>

  <!-- Employer Statutory Allocations -->
  <div style="margin-top: 25px;">
    <div class="a4-sec-title">Employer Statutory Allocations (Company Overhead)</div>
    <div class="a4-summary-left-card" style="width: 100%;">
      <div class="a4-info-row">
        <span class="a4-info-label">EPF Employer Contribution (12%)</span>
        <span class="a4-info-value">LKR {{ employerEpf }}</span>
      </div>
      <div class="a4-info-row">
        <span class="a4-info-label">ETF Employer Contribution (3%)</span>
        <span class="a4-info-value">LKR {{ employerEtf }}</span>
      </div>
      <div class="a4-info-row" style="font-weight: 700;">
        <span class="a4-info-label" style="font-weight: 700; color: #000;">Total Statutory Company Overhead (15%)</span>
        <span class="a4-info-value" style="font-size: 1.0em;">LKR {{ companyGovtAllocation }}</span>
      </div>
    </div>
  </div>

  <!-- Signature Section -->
  <div class="a4-signature-section">
    <div class="a4-sig-block">
      <div class="a4-sig-line"></div>
      <div class="a4-sig-label">Prepared By</div>
    </div>
    <div class="a4-sig-block">
      <div class="a4-sig-line"></div>
      <div class="a4-sig-label">Approved By (Management)</div>
    </div>
    <div class="a4-sig-block">
      <div class="a4-sig-line"></div>
      <div class="a4-sig-label">Employee Signature</div>
    </div>
  </div>

  <!-- Bottom Footer -->
  <div class="a4-ftr">
    <div class="a4-ftr-thank">Confidential Salary Payment Voucher</div>
    <div class="a4-ftr-powered">Powered by TaproPOS</div>
  </div>
</div>
`;

export const PAYROLL_PAYSLIP_CSS = `*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: Arial, Helvetica, sans-serif;
  font-size: var(--inv-font, 13px);
  color: #000;
  background: #fff;
  padding: 0;
  line-height: 1.4;
  -webkit-print-color-adjust: exact;
}

/* ── A4 Invoice Layout Styles ────────────────────────── */
.a4-container {
  display: flex;
  flex-direction: column;
  font-family: Arial, Helvetica, sans-serif;
  font-size: var(--inv-font, 13px);
  color: #000;
  background: #fff;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.a4-hdr-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.a4-hdr-left {
  width: 50%;
  flex: 0 0 50%;
}

.a4-hdr-logo-img {
  max-height: 70px;
  max-width: 100%;
  object-fit: contain;
}

.a4-hdr-right-store {
  width: 50%;
  flex: 0 0 50%;
  text-align: right;
}

.a4-hdr-right-store .store-title {
  font-size: 1.4em;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.a4-hdr-right-store p {
  font-size: 0.9em;
  margin: 2px 0;
  color: #333;
}

.a4-meta-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1.5px solid #000;
  border-bottom: 1.5px solid #000;
  padding: 8px 10px;
  margin-bottom: 20px;
  background-color: #f8f9fa;
  font-size: 0.9em;
}

.a4-meta-col {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.a4-meta-col.text-right {
  align-items: flex-end;
}

.a4-meta-lbl {
  font-size: 0.78em;
  text-transform: uppercase;
  color: #555;
  letter-spacing: 0.5px;
}

.a4-meta-val {
  font-size: 0.95em;
  color: #000;
}

.status-badge-a4 {
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 700;
  font-size: 0.85em;
  text-transform: uppercase;
  background-color: #e9ecef;
  color: #212529;
}

.a4-cust-card {
  margin: 10px 0 20px 0;
  font-size: 0.92em;
}

.a4-cust-grid {
  display: grid;
  grid-template-columns: 140px 1fr 140px 1fr;
  gap: 6px 12px;
}

@media (max-width: 600px) {
  .a4-cust-grid {
    grid-template-columns: 140px 1fr;
  }
}

.a4-cust-lbl {
  font-weight: 500;
  color: #444;
}

.a4-cust-val {
  font-weight: 700;
  text-transform: uppercase;
  color: #000;
}

.a4-items-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  font-size: 0.92em;
}

.a4-items-table th,
.a4-items-table td {
  border: 1px solid #888;
  padding: 7px 10px;
}

.a4-items-table th {
  background-color: #f2f2f2;
  font-weight: 700;
  text-transform: uppercase;
}

.a4-col-no {
  width: 6%;
  text-align: center;
}

.a4-col-desc {
  width: 48%;
  text-align: left;
}

.a4-col-earnings {
  width: 23%;
  text-align: right;
}

.a4-col-deductions {
  width: 23%;
  text-align: right;
}

.a4-item-row td {
  vertical-align: middle;
}

.a4-item-row .a4-desc-cell {
  text-align: left;
}

.a4-item-row .a4-amount-cell {
  text-align: right;
  font-weight: 500;
}

/* ── Modern Summary Section ── */
.a4-summary-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 20px;
  gap: 20px;
}

.a4-summary-left-card {
  width: 50%;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #dee2e6;
  padding: 12px 14px;
}

.a4-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 6px;
  margin-bottom: 6px;
}

.a4-info-row:last-child {
  border-bottom: none;
  padding-bottom: 0;
  margin-bottom: 0;
}

.a4-info-label {
  color: #495057;
  font-weight: 500;
  font-size: 0.88em;
}

.a4-info-value {
  font-weight: 700;
  color: #212529;
  font-size: 0.88em;
}

.a4-summary-right-totals {
  width: 45%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: right;
}

.a4-total-row {
  display: flex;
  justify-content: space-between;
  font-size: 0.92em;
  color: #495057;
}

.a4-total-lbl {
  font-weight: 500;
}

.a4-total-val {
  font-weight: 600;
}

.a4-grand-total-row {
  display: flex;
  justify-content: space-between;
  border-top: 2px solid #212529;
  border-bottom: 2px solid #212529;
  padding: 8px 0;
  margin-top: 5px;
}

.a4-grand-lbl {
  font-weight: 700;
  font-size: 1.1em;
  color: #212529;
}

.a4-grand-val {
  font-weight: 700;
  font-size: 1.1em;
  color: #212529;
}

/* ── Section Title ── */
.a4-sec-title {
  font-size: 0.95em;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 8px;
  border-bottom: 1.5px solid #212529;
  padding-bottom: 4px;
  color: #212529;
}

/* ── Signature Section ── */
.a4-signature-section {
  display: flex;
  justify-content: space-between;
  margin-top: 45px;
  margin-bottom: 20px;
  padding: 0 10px;
}

.a4-sig-block {
  width: 200px;
  text-align: center;
}

.a4-sig-line {
  border-top: 1px solid #333;
  margin-bottom: 6px;
}

.a4-sig-label {
  font-size: 0.85em;
  font-weight: 600;
  color: #495057;
}

/* ── Footer ── */
.a4-ftr {
  text-align: center;
  margin-top: 25px;
  border-top: 1px solid #000;
  padding-top: 8px;
  font-size: 0.85em;
  line-height: 1.5;
}

.a4-ftr-thank {
  font-weight: 700;
  font-size: 1.0em;
}

.a4-ftr-powered {
  margin-top: 4px;
  font-size: 0.8em;
  color: #666;
}

@media print {
  body {
    background: #fff;
    padding: 0;
  }
  .a4-container {
    box-shadow: none;
    border: none;
    padding: 0;
    max-width: 100% !important;
    width: 100% !important;
  }
}
`;
